import request from '@/utils/request'


// 诉讼案件
export function crmLawcaseIndex(data) {
	return request({
		url: 'lawcase/index',
		method: 'post',
		data: data
	})
}


// 新增
export function crmLawcaseSave(data) {
	return request({
		url: 'lawcase/save',
		method: 'post',
		data: data
	})
}

// 修改
export function crmLawcaseUpdate(data) {
	return request({
		url: 'lawcase/update',
		method: 'post',
		data: data
	})
}

// 删除
export function crmLawcaseDelete(data) {
	return request({
		url: 'lawcase/delete',
		method: 'post',
		data: data
	})
}

// 详情
export function crmLawcaseRead(data) {
	return request({
		url: 'lawcase/read',
		method: 'post',
		data: data
	})
}


// 记录
export function crmLawcaseActionRecord(data) {
	return request({
		url: 'lawcase/actionrecord',
		method: 'post',
		data: data
	})
}

// 开庭信息
export function crmLawcaseCourtList(data) {
	return request({
		url: 'lawcase/courtlist',
		method: 'post',
		data: data
	})
}

// 新增开庭信息
export function crmLawcaseCourtSave(data) {
	return request({
		url: 'lawcase/save_court',
		method: 'post',
		data: data
	})
}

// 修改开庭信息
export function crmLawcaseCourtUpdate(data) {
	return request({
		url: 'lawcase/update_court',
		method: 'post',
		data: data
	})
}

// 删除开庭信息
export function crmLawcaseCourtDel(data) {
	return request({
		url: 'lawcase/del_court',
		method: 'post',
		data: data
	})
}

// 确认开庭信息
export function crmLawcaseCourtConfirm(data) {
	return request({
		url: 'lawcase/confirm_court',
		method: 'post',
		data: data
	})
}

// 取消开庭信息
export function crmLawcaseCourtCancel(data) {
	return request({
		url: 'lawcase/cancel_court',
		method: 'post',
		data: data
	})
}


// 保全信息
export function crmLawcasePreservationList(data) {
	return request({
		url: 'lawcase/preservation',
		method: 'post',
		data: data
	})
}

// 保全信息新增
export function crmLawcasePreservationSave(data) {
	return request({
		url: 'lawcase/save_preservation',
		method: 'post',
		data: data
	})
}

// 保全信息修改
export function crmLawcasePreservationUpdate(data) {
	return request({
		url: 'lawcase/update_preservation',
		method: 'post',
		data: data
	})
}

// 保全信息删除
export function crmLawcasePreservationDel(data) {
	return request({
		url: 'lawcase/del_preservation',
		method: 'post',
		data: data
	})
}

// 财务信息
export function crmLawcaseFinancelist(data) {
	return request({
		url: 'lawcase/financelist',
		method: 'post',
		data: data
	})
}

// 财务信息-新增未收款
export function crmLawcaseNoFinanceSave(data) {
	return request({
		url: 'lawcase/save_nofinance',
		method: 'post',
		data: data
	})
}

// 财务信息-修改未收款
export function crmLawcaseNoFinanceUpdate(data) {
	return request({
		url: 'lawcase/update_nofinance',
		method: 'post',
		data: data
	})
}

// 财务信息-删除未收款
export function crmLawcaseNoFinanceDel(data) {
	return request({
		url: 'lawcase/del_nofinance',
		method: 'post',
		data: data
	})
}

// 财务信息-新建收款
export function crmLawcaseFinanceSave(data) {
	return request({
		url: 'lawcase/save_finance',
		method: 'post',
		data: data
	})
}

// 财务信息-修改收款
export function crmLawcaseFinanceUpdate(data) {
	return request({
		url: 'lawcase/update_finance',
		method: 'post',
		data: data
	})
}

// 财务信息-删除收款
export function crmLawcaseFinanceDel(data) {
	return request({
		url: 'lawcase/del_finance',
		method: 'post',
		data: data
	})
}

// 财务信息-审核收款
export function crmLawcaseFinanceConfirm(data) {
	return request({
		url: 'lawcase/confirm_finance',
		method: 'post',
		data: data
	})
}

// 财务信息-转烂账
export function crmLawcaseTobadDebt(data) {
	return request({
		url: 'lawcase/tobad_debt',
		method: 'post',
		data: data
	})
}

// 财务信息-新增开票
export function crmLawcaseInvoiceSave(data) {
	return request({
		url: 'lawcase/save_invoice',
		method: 'post',
		data: data
	})
}

// 财务信息-修改开票
export function crmLawcaseInvoiceUpdate(data) {
	return request({
		url: 'lawcase/update_invoice',
		method: 'post',
		data: data
	})
}

// 财务信息-删除开票
export function crmLawcaseInvoiceDel(data) {
	return request({
		url: 'lawcase/del_invoice',
		method: 'post',
		data: data
	})
}

// 财务信息-新增退费
export function crmLawcaseReturnSave(data) {
	return request({
		url: 'lawcase/save_return',
		method: 'post',
		data: data
	})
}

// 财务信息-修改退费
export function crmLawcaseReturnUpdate(data) {
	return request({
		url: 'lawcase/update_return',
		method: 'post',
		data: data
	})
}

// 财务信息-删除退费
export function crmLawcaseReturnDel(data) {
	return request({
		url: 'lawcase/del_return',
		method: 'post',
		data: data
	})
}

// 进度日志
export function crmLawcaseLogList(data) {
	return request({
		url: 'lawcase/loglist',
		method: 'post',
		data: data
	})
}

// 进度日志新增
export function crmLawcaseLogSave(data) {
	return request({
		url: 'lawcase/save_log',
		method: 'post',
		data: data
	})
}

// 进度日志修改
export function crmLawcaseLogUpdate(data) {
	return request({
		url: 'lawcase/update_log',
		method: 'post',
		data: data
	})
}

// 进度日志删除
export function crmLawcaseLogDel(data) {
	return request({
		url: 'lawcase/del_log',
		method: 'post',
		data: data
	})
}


// 判决
export function crmLawcaseJudgmentList(data) {
	return request({
		url: 'lawcase/judgmentlist',
		method: 'post',
		data: data
	})
}

// 判决新增
export function crmLawcaseJudgmentSave(data) {
	return request({
		url: 'lawcase/save_judgment',
		method: 'post',
		data: data
	})
}

// 判决修改
export function crmLawcaseJudgmentUpdate(data) {
	return request({
		url: 'lawcase/update_judgment',
		method: 'post',
		data: data
	})
}

// 判决删除
export function crmLawcaseJudgmentDel(data) {
	return request({
		url: 'lawcase/del_judgment',
		method: 'post',
		data: data
	})
}


// 客户反馈
export function crmLawcaseLawcasecomplainList(data) {
	return request({
		url: 'lawcase/lawcasecomplainlist',
		method: 'post',
		data: data
	})
}

// 客户反馈新增
export function crmLawcaseLawcasecomplainSave(data) {
	return request({
		url: 'lawcase/save_lawcasecomplain',
		method: 'post',
		data: data
	})
}

// 客户反馈修改
export function crmLawcaseLawcasecomplainUpdate(data) {
	return request({
		url: 'lawcase/update_lawcasecomplain',
		method: 'post',
		data: data
	})
}

// 客户反馈删除
export function crmLawcaseLawcasecomplainDel(data) {
	return request({
		url: 'lawcase/del_lawcasecomplain',
		method: 'post',
		data: data
	})
}

// 日志首页
export function crmLawcaseLogIndex(data) {
	return request({
		url: 'lawcase/logindex',
		method: 'post',
		data: data
	})
}

// 开庭首页
export function crmLawcaseCourtIndex(data) {
	return request({
		url: 'lawcase/courtindex',
		method: 'post',
		data: data
	})
}

// 判决首页
export function crmLawcaseJudgmentIndex(data) {
	return request({
		url: 'lawcase/judgmentindex',
		method: 'post',
		data: data
	})
}

// 保全首页
export function crmLawcasePreservationIndex(data) {
	return request({
		url: 'lawcase/preservationindex',
		method: 'post',
		data: data
	})
}

// 客户反馈首页
export function crmLawcaseComplainIndex(data) {
	return request({
		url: 'lawcase/lawcasecomplainindex',
		method: 'post',
		data: data
	})
}

// 结案
export function crmLawcaseClose(data) {
	return request({
		url: 'lawcase/close',
		method: 'post',
		data: data
	})
}

// 归档
export function crmLawcaseAllclose(data) {
	return request({
		url: 'lawcase/allclose',
		method: 'post',
		data: data
	})
}

// 案件统计
export function crmLawcaseStatistics(data) {
	return request({
		url: 'lawcase/statistics',
		method: 'post',
		data: data
	})
}

// 开庭统计
export function crmLawcaseCourtStatistics(data) {
	return request({
		url: 'lawcase/court_statistics',
		method: 'post',
		data: data
	})
}

// 费用申请
export function crmLawcaseApplyList(data) {
	return request({
		url: 'lawcase/applylist',
		method: 'post',
		data: data
	})
}

// 费用申请新增
export function crmLawcaseApplySave(data) {
	return request({
		url: 'lawcase/save_apply',
		method: 'post',
		data: data
	})
}

// 费用申请修改
export function crmLawcaseApplyUpdate(data) {
	return request({
		url: 'lawcase/update_apply',
		method: 'post',
		data: data
	})
}

// 费用申请删除
export function crmLawcaseApplyDel(data) {
	return request({
		url: 'lawcase/del_apply',
		method: 'post',
		data: data
	})
}

// 费用申请审核
export function crmLawcaseApplyConfirm(data) {
	return request({
		url: 'lawcase/confirm_apply',
		method: 'post',
		data: data
	})
}

// 付款
export function crmLawcaseApplyPay(data) {
	return request({
		url: 'lawcase/pay_apply',
		method: 'post',
		data: data
	})
}

// 获取案件状态
export function crmLawcaseStatusGet(data) {
	return request({
		url: 'lawcase/getstatus',
		method: 'post',
		data: data
	})
}

// 关注案件
export function crmLawcaseFocus(data) {
	return request({
		url: 'lawcase/focus',
		method: 'post',
		data: data
	})
}

/**
 * 导出
 * @param {*} data
 * customer_id 客户ID
 */
export function crmLawcaseExcelExport(data) {
	return request({
		url: 'lawcase/excelexport',
		method: 'post',
		data: data,
		responseType: 'blob',
		timeout: 600000
	})
}

// 获取详情的角标数量
export function getbadgenum(data) {
	return request({
		url: 'lawcase/getbadge',
		method: 'post',
		data: data
	})
}

// 法律文书
export function getfilenum(data) {
	return request({
		url: 'lawcase/filelist',
		method: 'post',
		data: data
	})
}

// 合作律师
export function crmCooperatelawyerIndex(data) {
	return request({
		url: 'lawcase/cooperatelawyer',
		method: 'post',
		data: data
	})
}

// 合作律师-新增
export function crmCooperatelawyerSave(data) {
	return request({
		url: 'lawcase/save_cooperatelawyer',
		method: 'post',
		data: data
	})
}

// 合作律师-修改
export function crmCooperatelawyerUpdate(data) {
	return request({
		url: 'lawcase/update_cooperatelawyer',
		method: 'post',
		data: data
	})
}

// 合作律师-删除
export function crmCooperatelawyerDel(data) {
	return request({
		url: 'lawcase/del_cooperatelawyer',
		method: 'post',
		data: data
	})
}

